import './Modal.scss';
import { forwardRef } from 'react';
import { Dialog } from "primereact/dialog";
import { classNames } from "primereact/utils"

const Modal = forwardRef((props, ref) => {
  const { children, className, maskClassName,...restProps } = props

  return (
    <Dialog 
      ref={ref}
      blockScroll={true}
      maskClassName={classNames("ModalMask", maskClassName)} 
      className={classNames('Modal', className)}   
   
      {...restProps} 
    >

      {children}
    </Dialog>
  )
})




Modal.defaultProps = {
  visible: false,
}

export default Modal;
